export default [
  {
    path: '/admin/sale-location-tracking',
    name: 'location-tracking',
    meta: { requiresAuth: true },
    component: () => import('@/pages/sale/tracking/index.vue')
  }
]